"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parcelStatuses = exports.orderStatuses = void 0;
exports.orderStatuses = ["ORDERED", "REFUNDED", "CANCELLED", "PARTIALLY-FULFILLED", "FULFILLED", "PROCESSING", "POS-ORDERED"];
exports.parcelStatuses = ["OPEN", "PACKED", "READY", "COLLECTED", "IN-TRANSIT", "ARRIVED", "DELIVERED", "ABANDONED"];
